"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useState } from "react";
interface GradientBorderLinkProps {
  href: string;
  children: React.ReactNode;
}
const GRADIENT_STYLE = {
  background: "linear-gradient(var(--background), var(--background)) padding-box, " + "linear-gradient(269.48deg, #1BC4F9 3.26%, #5A6BE0 65.08%, #DC41CA 135.82%) border-box"
};
const HOVER_STYLE = {
  background: "#ffffff"
};
export default function GradientBorderLink(t0) {
  const $ = _c(9);
  const {
    href,
    children
  } = t0;
  const [hovered, setHovered] = useState(false);
  const t1 = hovered ? HOVER_STYLE : GRADIENT_STYLE;
  const t2 = `inline-flex min-h-12 w-full min-w-45 items-center justify-center gap-2 rounded-full border px-6 py-2 text-[15px] font-semibold transition-all duration-300 ease-out min-[500px]:w-auto min-[500px]:px-7 lg:w-50 ${hovered ? "border-[#141B2A] text-[#141B2A] lg:w-98.75" : "border-transparent text-white"}`;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setHovered(true);
    t4 = () => setHovered(false);
    t5 = () => setHovered(true);
    t6 = () => setHovered(false);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t3 = $[0];
    t4 = $[1];
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] !== children || $[5] !== href || $[6] !== t1 || $[7] !== t2) {
    t7 = <Link href={href} style={t1} className={t2} onMouseEnter={t3} onMouseLeave={t4} onFocus={t5} onBlur={t6}>{children}</Link>;
    $[4] = children;
    $[5] = href;
    $[6] = t1;
    $[7] = t2;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}